module.exports = __webpack_public_path__ + "img/PortVilaMap-light.d4fa63d3.jpg";